var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForgotPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.65,228.65a23.66,23.66,0,1,0-.28-37.13h0l-5.18-4-7.71,2.41.88-7.71-6.5-5.05-7.7,2.4.88-7.71-5.59-4.34-4.7,1.46.54-4.7L151,161.72l-7.38.72-1,11.34,38.66,30.05A23.68,23.68,0,0,0,189.65,228.65Zm28.17-8.07a6.78,6.78,0,1,1-1.2-9.52A6.8,6.8,0,0,1,217.82,220.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.81,138.27a12.67,12.67,0,1,0-19.88-.34h0l-2.23,2.72,1.19,4.16-4.12-.57L193,147.66l1.19,4.16-4.11-.58-2.4,2.94.72,2.53-2.51-.35-1.39,1.71.29,4,6.06.68,16.58-20.31A12.68,12.68,0,0,0,220.81,138.27Zm-4-15.18a3.63,3.63,0,1,1-5.11.51A3.62,3.62,0,0,1,216.85,123.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.32 52.37 167.32 125.75 61.91 125.75 58.12 52.88 167.32 52.37",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.46,
    y: 36.54,
    width: 72.72,
    height: 105.41,
    transform: "translate(21.58 200.06) rotate(-90)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164,126.1H57.62V52.38H164Zm-105.4-1H163V53.38H58.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.53,
    y: 61.91,
    width: 82.57,
    height: 54.65,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.11,61.91l-.41,0h-1.18L146,62,129,62l-59.44.12.24-.24c0,16.7,0,35.2,0,54.65h0l-.26-.26,82.58.06-.21.2c0-16.63.08-30.26.11-39.76,0-4.75,0-8.45.05-11,0-1.26,0-2.22,0-2.89s0-1,0-1,0,.32,0,1,0,1.61,0,2.85c0,2.53,0,6.23,0,11,0,9.53.07,23.21.11,39.89v.21h-.2l-82.58,0h-.26v-.27h0c0-19.45,0-37.95,0-54.65v-.24h.24l59.6.12,17,.07,4.49,0,1.15,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,52.67a9.18,9.18,0,0,1,1.82,1.18c1.08.78,2.54,1.88,4.13,3.15s3,2.47,4,3.37a8.73,8.73,0,0,1,1.51,1.54c-.1.11-2.63-2-5.8-4.5A59.17,59.17,0,0,1,58.11,52.67Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.52,52.88A52,52,0,0,1,158,57.6a52.17,52.17,0,0,1-5.87,4.31,52,52,0,0,1,5.54-4.72A51.6,51.6,0,0,1,163.52,52.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.44,125.61l-11.75-9.53",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.69,116.08a56,56,0,0,1,6,4.56,57.06,57.06,0,0,1,5.71,5,54.92,54.92,0,0,1-6-4.56A53,53,0,0,1,151.69,116.08Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.11,125.6a50.8,50.8,0,0,1,5.49-4.67,51.62,51.62,0,0,1,5.81-4.27,48.33,48.33,0,0,1-5.48,4.68A50.73,50.73,0,0,1,58.11,125.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103.13,
    y: 62.11,
    width: 18.3,
    height: 51.96,
    transform: "translate(24.19 200.37) rotate(-90)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M429,469.2c0,.14-85.88.26-191.8.26s-191.83-.12-191.83-.26,85.87-.26,191.83-.26S429,469.06,429,469.2Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "348.79 433 373.54 468.99 382.39 469.2 366.17 432.19 348.79 433",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.62 434.83 74.58 468.83 81.1 468.83 103.87 434.98 87.62 434.83",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82,311.3l1,44a11.62,11.62,0,0,0,11.36,11.37l246.19,5.48a11.63,11.63,0,0,0,11.89-11.63v-53a31.31,31.31,0,0,0-27-31c-45.07-6.2-138-15.73-213.15-2.19A36.77,36.77,0,0,0,82,311.3Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.92,326.67s-20.28-9.39-24.43,0S57,347.58,61.56,354s4.54,85.74,4.54,85.74l307.58-3.29,3.64-76.27s14.75-18.17,13.83-26-13.37-19.23-27.66-7.54-18,36.12-18,36.12l-245.23,1.85S101.1,330.3,80.92,326.67Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.38,378c0,.14-54.49.26-121.69.26S99,378.17,99,378s54.47-.26,121.69-.26S342.38,377.88,342.38,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99,411.6a.75.75,0,0,1,0-.24c0-.19,0-.43,0-.71q0-.94-.06-2.73c0-2.41,0-5.82,0-10,0-8.46.06-20.15-.33-33a140.27,140.27,0,0,0-1.4-18.08c-.18-.66-.36-1.32-.53-2s-.5-1.25-.76-1.86c-.53-1.21-1.07-2.37-1.66-3.46a36.86,36.86,0,0,0-3.74-5.75,26.7,26.7,0,0,0-4-4,21.73,21.73,0,0,0-3.59-2.32,36.31,36.31,0,0,0-3.39-1.36l.23,0,.69.19a14.77,14.77,0,0,1,2.56,1,19.72,19.72,0,0,1,3.68,2.27,26.1,26.1,0,0,1,4.08,4,36.24,36.24,0,0,1,3.84,5.78c.61,1.1,1.16,2.26,1.7,3.48.27.61.52,1.24.77,1.87l.57,2a135,135,0,0,1,1.45,18.17c.39,12.9.26,24.59.18,33.05-.06,4.19-.11,7.6-.14,10,0,1.15,0,2.06,0,2.73l0,.7C99,411.51,99,411.6,99,411.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.53,344.37a1.44,1.44,0,0,1,.81-.25,3.44,3.44,0,0,1,2.26.63A3.52,3.52,0,0,1,82.7,346a3.05,3.05,0,0,1,.29,1.9A3.73,3.73,0,0,1,80.12,351a3.8,3.8,0,0,1-3.8-1.81,3.44,3.44,0,0,1-.49-1.86A3.84,3.84,0,0,1,78,344.07a1.75,1.75,0,0,1,.83-.21c0,.05-.29.12-.74.39a3.85,3.85,0,0,0-1.45,1.62,3.08,3.08,0,0,0,.12,3,3.36,3.36,0,0,0,3.3,1.55,3.29,3.29,0,0,0,2.49-2.63,2.83,2.83,0,0,0-1.14-2.77,3.36,3.36,0,0,0-2-.73C78.83,344.32,78.54,344.42,78.53,344.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.92,364.11a4.73,4.73,0,0,1-1.39-1.64,9.83,9.83,0,0,1-.12-10,4.87,4.87,0,0,1,1.35-1.68c.07.06-.45.69-1,1.85a10.63,10.63,0,0,0-1.12,4.84,10.75,10.75,0,0,0,1.23,4.82C79.45,363.44,80,364.06,79.92,364.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.7,334.42a8.44,8.44,0,0,1-.3,1.5,9.22,9.22,0,0,0,1.46,6.87,11.39,11.39,0,0,1,.89,1.24s-.56-.28-1.19-1A8.09,8.09,0,0,1,76,335.83,3.19,3.19,0,0,1,76.7,334.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71,345.48c.12-.1,1.05.84,2.47,1.57s2.71,1,2.69,1.12a4.39,4.39,0,0,1-2.93-.66A4.47,4.47,0,0,1,70.71,345.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.86,411.6c0,.14-69.37.26-154.94.26S65,411.74,65,411.6s69.36-.26,155-.26S374.86,411.45,374.86,411.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.31,363.05c.15,0,.26,10.86.26,24.25s-.11,24.27-.26,24.27-.26-10.86-.26-24.27S341.17,363.05,341.31,363.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,279.14l-.48,0-1.4.05-5.37.15-19.78.46-65.24,1.31c-6.37.15-12.6.13-18.58.53a62.75,62.75,0,0,0-16.93,3.09A29.88,29.88,0,0,0,98,293.2,28.22,28.22,0,0,0,94,299a37.06,37.06,0,0,0-2.45,6,56.64,56.64,0,0,0-2,11c-.31,3.3-.34,6.15-.36,8.49s0,4.14.07,5.37c0,.6,0,1.06,0,1.4s0,.48,0,.48,0-.16,0-.48,0-.8-.08-1.4c-.06-1.22-.14-3-.16-5.37s0-5.2.27-8.52a56.54,56.54,0,0,1,2-11.11,37.58,37.58,0,0,1,2.44-6.11,28.14,28.14,0,0,1,4-5.92,30.29,30.29,0,0,1,13-8.6,62.4,62.4,0,0,1,17-3.15c6-.4,12.24-.39,18.61-.54l65.25-1.16,19.77-.29,5.38-.06h1.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.86,313.4s-.33.16-.84.55a4.57,4.57,0,0,0-1.55,2.17,3.84,3.84,0,0,0,.55,3.71,4,4,0,0,0,7.31-1.74,3.88,3.88,0,0,0-1.18-3.57,4.6,4.6,0,0,0-2.36-1.23c-.63-.11-1-.07-1-.11a1.93,1.93,0,0,1,1-.09,4.66,4.66,0,0,1,3.75,2.79,4.12,4.12,0,0,1,.23,2.3,4.51,4.51,0,0,1-8.16,1.94,4.14,4.14,0,0,1-.83-2.15,4.64,4.64,0,0,1,.31-2,4.53,4.53,0,0,1,1.78-2.21A2,2,0,0,1,159.86,313.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.65,339.31a12.1,12.1,0,0,1-.76-3,17,17,0,0,1,.16-7.38,10.1,10.1,0,0,1,4.31-5.94,6.75,6.75,0,0,1,2.09-.85,2,2,0,0,1,.82-.08,12.77,12.77,0,0,0-2.72,1.24,10.26,10.26,0,0,0-4,5.77,18.67,18.67,0,0,0-.3,7.18C155.49,338.15,155.73,339.29,155.65,339.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.29,298a23.43,23.43,0,0,0-1.47,2.2,8.76,8.76,0,0,0,2.57,11.28,21.74,21.74,0,0,0,2.29,1.35,1.84,1.84,0,0,1-.72-.15,7.76,7.76,0,0,1-1.78-.9A8.7,8.7,0,0,1,157.49,300a7.62,7.62,0,0,1,1.22-1.58C159.05,298.07,159.27,297.93,159.29,298Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.37,318a50.29,50.29,0,0,0-5.42,1.22,51.91,51.91,0,0,0-5.06,2.3A14.47,14.47,0,0,1,158.37,318Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126.06,378.94a50.26,50.26,0,0,0,34,10.25q-3.8,17.63-7.58,35.27c-.67,3.13-1.3,6.62.34,9.38,2.3,3.87,7.65,4.25,12.15,4.19,5-.07,10.22-.19,14.66-2.51,6.29-3.28,9.67-10.24,12.11-16.9s4.55-13.8,9.57-18.81a39,39,0,0,0,22.15,12.61c2.5.46,5.34.6,7.34-1s2.57-4.42,2.06-6.9a20.7,20.7,0,0,0-3.27-6.79l-14.64-22.7c-2-3.07-4.14-6.31-7.49-7.77-2.63-1.15-5.61-1-8.47-.87a390.91,390.91,0,0,0-70.87,10.71"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M204.28,266.4c-5.92,15.64-28,19.23-35.79,34-7.67,14.64,1.84,34-6.06,48.56-2.93,5.38-8,9.39-10.82,14.81-1.92,3.64-2.91,8-6,10.69-3.62,3.15-9.23,3.09-13.58,1.05s-7.69-5.7-10.79-9.37c-5.8-6.88-11.25-14.32-14-22.91-4.66-14.77-.38-31.48,9-43.82s23.27-20.67,37.94-25.66,30.19-6.87,45.62-8.32"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M133.18,225.27a24.3,24.3,0,0,1,9-8.31,15.92,15.92,0,0,1,12-1.21,11.92,11.92,0,0,1,8,8.64c.63,3.21-.23,6.79,1.43,9.61,1.9,3.24,6.49,4.26,8.11,7.66a7.39,7.39,0,0,1-.49,6.53,20.31,20.31,0,0,1-4.39,5.14,10.75,10.75,0,0,1,2.74,2.46,3.73,3.73,0,0,1,.58,3.5,5.14,5.14,0,0,1-3,2.4,29.55,29.55,0,0,1-17.69,1.66c-1.58-.34-3.39-.77-4.69.19",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.21,237.14,170,246.93l21.86,12.41-22,.71,1.64,17.83,42.35-10.4s2.54-17.27-40.64-30.34l-3-.72a3.43,3.43,0,0,1-2.41-2.09h0A3.71,3.71,0,0,0,166,232.4l-3.61-1.88,0,2.86,2,2.33-.32,5.53a5,5,0,0,0,3.84,5.22l2,.47",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.32,272.54c-.87,0-8.94,2-13.56,7.84s-11.3,27.94-11.3,27.94l17,2.94,7.34,18.43s43.45-5.69,41.14-8a89.12,89.12,0,0,0-7-5.81l10-33.31,12-6.48-4.05-16.64-24.17,3.27Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.86,290.27c0,.14-13.55.26-30.25.26s-30.26-.12-30.26-.26,13.55-.26,30.26-.26S166.86,290.13,166.86,290.27Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.15,300.06c0,.14-13.55.26-30.25.26s-30.26-.12-30.26-.26,13.54-.26,30.26-.26S164.15,299.92,164.15,300.06Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.15,310.63c0,.15-10.26.27-22.92.27s-22.91-.12-22.91-.27,10.26-.26,22.91-.26S164.15,310.49,164.15,310.63Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.66,320.82c0,.14-10.26.26-22.91.26s-22.91-.12-22.91-.26,10.25-.26,22.91-.26S167.66,320.67,167.66,320.82Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.51,277.1c0,.15-6.78.26-15.13.26s-15.14-.11-15.14-.26,6.77-.26,15.14-.26S178.51,277,178.51,277.1Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.61,266.72c0,.15-6.75.42-15.07.61s-15.09.24-15.09.1,6.74-.42,15.07-.62S179.61,266.58,179.61,266.72Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,295.35a66.55,66.55,0,0,1-1.63,8.18,68,68,0,0,1-2.13,8.07,68,68,0,0,1,1.62-8.18A64.69,64.69,0,0,1,121,295.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "168.3 420.21 155.64 460.14 170.9 461.68 185.24 426.98 168.3 420.21",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.47,446.14l-7.27,18s15.88,13.45,14.86,16.91L151.6,468.24l10.17-28.56Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.79,458.66a1.54,1.54,0,0,0-1.6,1.29,1.48,1.48,0,0,0,1.26,1.6,1.63,1.63,0,0,0,1.69-1.37c0-.76-.75-1.63-1.5-1.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,468.24l1.14-2.84,33.58,13.38s1.33,1.25.74,2.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.84,464.2c-.07.17-1-.06-2,.18s-1.77.82-1.9.69.48-1,1.76-1.31S172.93,464.05,172.84,464.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176,467.08c0,.19-.88.21-1.73.73S173,469,172.8,469s.07-1.09,1.14-1.71S176.06,466.92,176,467.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,472.3c-.17,0-.1-1,.69-1.76s1.74-.87,1.76-.7-.67.5-1.3,1.15S176.68,472.35,176.5,472.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174,459.91c-.13.13-.84-.4-1.84-.69s-1.88-.25-1.92-.43.93-.54,2.1-.18S174.17,459.8,174,459.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.44,456.24a3.59,3.59,0,0,1-1.77-.65,8.06,8.06,0,0,1-1.65-1.25,7.3,7.3,0,0,1-.83-.91,2.29,2.29,0,0,1-.38-.61.8.8,0,0,1,.25-.95,1,1,0,0,1,.9-.12,2.92,2.92,0,0,1,.64.33,6.93,6.93,0,0,1,1,.78,6.71,6.71,0,0,1,1.25,1.67,3.12,3.12,0,0,1,.52,1.82c-.1,0-.3-.66-.91-1.59a7.35,7.35,0,0,0-1.26-1.46,5.87,5.87,0,0,0-.91-.69c-.34-.23-.66-.35-.81-.22s-.07.08,0,.21a2.23,2.23,0,0,0,.29.45,11.07,11.07,0,0,0,.74.88,11.36,11.36,0,0,0,1.48,1.28A12.64,12.64,0,0,1,175.44,456.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.12,456.41a3,3,0,0,1,.16-1.89,6.06,6.06,0,0,1,1.79-2.77,1.57,1.57,0,0,1,1.45-.49.91.91,0,0,1,.57.77,2.33,2.33,0,0,1-.06.72,4.11,4.11,0,0,1-.43,1.19,4.27,4.27,0,0,1-1.42,1.56c-1,.67-1.83.62-1.82.55a14.63,14.63,0,0,0,1.55-.91,4.34,4.34,0,0,0,1.17-1.47,4.1,4.1,0,0,0,.34-1c.08-.39.05-.75-.11-.76s-.58.11-.83.36a6,6,0,0,0-.79.8,7.2,7.2,0,0,0-1,1.65C175.28,455.7,175.23,456.42,175.12,456.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.35 382.62 235.25 415.47 250.71 405.55 231.73 372.2 216.35 382.62",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.37,396.16,255.14,413s20.36-4.28,22.47-1.35l-31.92,20.1L229.4,406.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.39,417.81a1.53,1.53,0,0,0,0,2.05,1.48,1.48,0,0,0,2,0,1.63,1.63,0,0,0-.05-2.18,1.55,1.55,0,0,0-2.12.25",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.69,431.73l-1.54-2.64,31.18-18.28s1.81-.28,2.28.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.55,412.49c.09.16-.64.72-1.09,1.7s-.45,1.9-.63,1.93-.52-1,0-2.2S255.49,412.32,255.55,412.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.77,411.76c.13.13-.38.82-.49,1.82s.17,1.78,0,1.87-.81-.72-.65-2S259.67,411.62,259.77,411.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.2,414.57c-.13.13-.83-.51-1-1.62s.38-1.9.53-1.82,0,.83.11,1.74S264.34,414.46,264.2,414.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.9,408.9c0,.19-.83.42-1.67,1s-1.35,1.32-1.52,1.24.15-1.06,1.15-1.77S252.9,408.73,252.9,408.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.87,405.55c0,.06-.51.55-1.6,1a9.28,9.28,0,0,1-2,.54,11.84,11.84,0,0,1-1.23.09,2.47,2.47,0,0,1-.72-.08.8.8,0,0,1-.59-.78,1,1,0,0,1,.46-.79,2.78,2.78,0,0,1,.65-.29,6.55,6.55,0,0,1,3.29-.25c1.18.22,1.8.65,1.76.71s-.7-.17-1.81-.26a7.78,7.78,0,0,0-1.94.1,6.79,6.79,0,0,0-1.09.29c-.4.13-.69.31-.68.51s0,.1.15.16a2,2,0,0,0,.53.05,10.14,10.14,0,0,0,3.06-.43A12.56,12.56,0,0,1,250.87,405.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.81,405.9c0,.06-.7-.31-1.4-1.28a6,6,0,0,1-.88-1.89,6.61,6.61,0,0,1-.21-1.22,1.57,1.57,0,0,1,.52-1.45.88.88,0,0,1,.94,0,2.59,2.59,0,0,1,.54.48,4.64,4.64,0,0,1,.68,1.08,4.38,4.38,0,0,1,.35,2.08c-.1,1.22-.63,1.82-.68,1.77a15.71,15.71,0,0,0,.23-1.78,4.35,4.35,0,0,0-.44-1.82,3.82,3.82,0,0,0-.61-.91c-.26-.3-.56-.5-.67-.38a1.06,1.06,0,0,0-.23.87,6.58,6.58,0,0,0,.15,1.12,6.75,6.75,0,0,0,.7,1.79C250.34,405.34,250.88,405.82,250.81,405.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.09,378l37.12-25.24,23.41,45.57L241.9,386.8S217.39,327,208.59,325.1c-4.93-1.08-61.47,9.71-61.47,9.71l-6.32-3.17-16-1.95-1,2.59a54.58,54.58,0,0,0,1.78,44.12l.78,1.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.06,346.42c.28,1.25,31,30,31,30l-17.7,59.49,26.42,5.05,26.53-71.66-48.49-47.57L142.63,331Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.21,352.75c.08.12-8.17,5.86-18.41,12.83S160.18,378.1,160.09,378s8.16-5.87,18.41-12.84S197.12,352.63,197.21,352.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.26,389.83a8.76,8.76,0,0,1-.9-1.37c-.55-.9-1.31-2.23-2.24-3.87-1.85-3.29-4.31-7.89-6.91-13s-4.9-9.82-6.51-13.23c-.81-1.71-1.45-3.1-1.88-4.06a8.34,8.34,0,0,1-.61-1.52,11,11,0,0,1,.8,1.43l2,4c1.74,3.45,4.07,8.06,6.64,13.17s5,9.75,6.77,13.08c.85,1.61,1.56,2.94,2.1,3.95A10.33,10.33,0,0,1,216.26,389.83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.57,365.78a47.58,47.58,0,0,1-2.84,6.38,47.54,47.54,0,0,1-3.31,6.14,93.88,93.88,0,0,1,6.15-12.52Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.46,308.32l-6,22.16a11.56,11.56,0,0,0,1,8.53h0a11.62,11.62,0,0,0,12.85,5.81l47.55-11.71-5-9.88-37.46,3.25,4-15.22Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.55 341.95 122.17 338.73 147.94 334.1 155.43 294.37 203.29 288.67 195.25 331.08 121.55 341.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.92,315.77a2.7,2.7,0,1,1,2.77-2.19A2.51,2.51,0,0,1,176.92,315.77Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.55,228l.09,2.87,1.08,43c.13,5,4.52,8.86,9.86,8.68h0c5.4-.17,9.74-4.4,9.7-9.45-.05-5.29,0-10.87,0-10.87s6.81-1.21,8.12-10.13c.65-4.43.34-11.69-.1-17.62a9.4,9.4,0,0,0-10.47-8.64Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.85,239.47a1.15,1.15,0,0,1-1.09,1.17,1.09,1.09,0,0,1-1.18-1,1.15,1.15,0,0,1,1.08-1.17A1.1,1.1,0,0,1,153.85,239.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.77,238.31c-.14.15-1-.48-2.24-.47s-2.12.65-2.26.5.08-.34.47-.63a3.15,3.15,0,0,1,1.8-.58,3.09,3.09,0,0,1,1.79.55C155.71,238,155.84,238.24,155.77,238.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.73,239.91a1.14,1.14,0,0,1-1.09,1.17,1.1,1.1,0,0,1-1.19-1,1.14,1.14,0,0,1,1.09-1.16A1.09,1.09,0,0,1,141.73,239.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.7,238.68c-.14.15-1-.48-2.24-.47s-2.12.65-2.26.5.07-.34.46-.63a3.18,3.18,0,0,1,1.81-.58,3.06,3.06,0,0,1,1.78.55C143.63,238.34,143.77,238.61,143.7,238.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.26,247.73a8.23,8.23,0,0,1,2-.38c.32,0,.61-.1.66-.32a1.56,1.56,0,0,0-.22-.92l-.95-2.38a40.94,40.94,0,0,1-2.16-6.22,39,39,0,0,1,2.65,6l.92,2.39a1.87,1.87,0,0,1,.18,1.23.81.81,0,0,1-.51.47,2.28,2.28,0,0,1-.54.08A7.85,7.85,0,0,1,148.26,247.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.28,262.26a22.62,22.62,0,0,1-12-3s3,6.08,11.86,5.14Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.19,236.65c-.13.33-1.35.12-2.8.22s-2.63.45-2.81.14c-.08-.15.14-.45.62-.75a4.62,4.62,0,0,1,2.11-.63,4.72,4.72,0,0,1,2.17.35C144,236.22,144.25,236.5,144.19,236.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.26,234c-.22.28-1.07,0-2.08,0s-1.88.21-2.08-.08,0-.42.41-.69a3,3,0,0,1,3.36.07C155.23,233.62,155.35,233.91,155.26,234Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.13,252.18a2.08,2.08,0,0,1-1.07-.11l-1-.28c-.28-.09-.59-.22-.94-.35a2,2,0,0,1-.92-.55c-.21-.27-.17-.75.31-1.18a2.59,2.59,0,0,1,4,1.33C148.72,251.67,148.46,252.09,148.13,252.18Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.3,252.07c-.12.09-.72-1.14-2.16-1.51a5.24,5.24,0,0,0-2.61.29s.16-.32.65-.57a3,3,0,0,1,2.09-.22,3,3,0,0,1,1.73,1.2C148.31,251.71,148.36,252.05,148.3,252.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.85,222.22a11.21,11.21,0,0,1-1.61,14c-2.13,2-5.3,3.53-5.51,6.43-.24,3.21,3.48,5.61,3.48,8.83s-3.81,5.42-4.56,8.65c-.6,2.6,1,5.2,2.76,7.17s4,3.71,5,6.15a10.92,10.92,0,0,1-.3,8.57,27.09,27.09,0,0,1-5,7.19,33.77,33.77,0,0,0-8.24-1.83c.17-1.06.35-2.13.53-3.19a2.93,2.93,0,0,1-2.15,2.7,7.89,7.89,0,0,1-3.68.05,59.84,59.84,0,0,1-11-2.83,19.79,19.79,0,0,0,4-5,6.67,6.67,0,0,0,.11-6.2c-.88-1.5-2.5-2.46-3.31-4-1.21-2.3-.21-5.22,1.51-7.17s4.06-3.22,6.11-4.82,3.93-3.76,4.09-6.36c.22-3.36-2.51-6.43-2.17-9.78.38-3.82,4.42-6.16,6-9.66,1.15-2.53,1-5.65,2.76-7.8a6.71,6.71,0,0,1,5.53-2.2,12.44,12.44,0,0,1,5.76,2",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150,263.22c-1.6.88-1.51,3.33-.53,4.88s2.55,2.66,3.52,4.22a6.92,6.92,0,0,1-1.63,8.82l3.84,1.45.84-.47,2.36-1.34-1.11,2.73h2.46a7,7,0,0,0,5.78-11.15c-1-1.4-2.58-2.51-2.93-4.2-.41-2.05,1.14-3.9,1.89-5.84a8.25,8.25,0,0,0-2.68-9.33",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.25,182.29A1.35,1.35,0,0,1,75,183.5v6.66a1.33,1.33,0,0,1-.53,1.06,1.3,1.3,0,0,1-1.17.22,4.21,4.21,0,0,0-3.26.5,3.73,3.73,0,0,0-1.78,2.38,3.8,3.8,0,0,0,.68,2.91,4.3,4.3,0,0,0,2.75,1.82,5,5,0,0,0,5.24-3.39,1.33,1.33,0,1,1,2.54.81,7.69,7.69,0,0,1-8.2,5.22,6.84,6.84,0,0,1-4.53-2.94,6.52,6.52,0,0,1-1.1-5,6.42,6.42,0,0,1,3-4.12,7,7,0,0,1,3.67-1V183.5a1.34,1.34,0,0,1,1.34-1.34A1.41,1.41,0,0,1,74.25,182.29Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.41,179.49a1.09,1.09,0,1,1,1.12,1.07A1.09,1.09,0,0,1,72.41,179.49Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105,215.15s-.33,0-.88.28A4,4,0,0,0,102.3,217a3.78,3.78,0,0,0-.57,1.58,3.31,3.31,0,0,0,.33,1.88,3.67,3.67,0,0,0,6.88-.4,3.31,3.31,0,0,0,.11-1.91,4,4,0,0,0-.75-1.51,4.1,4.1,0,0,0-2-1.36c-.57-.16-.91-.14-.91-.17l.24,0a1.73,1.73,0,0,1,.3,0,2.06,2.06,0,0,1,.39.06,4,4,0,0,1,2.16,1.34,3.91,3.91,0,0,1,.83,1.58,3.52,3.52,0,0,1-.09,2,4.14,4.14,0,0,1-1.28,1.87,3.89,3.89,0,0,1-2.25.93,3.93,3.93,0,0,1-2.34-.66,4.14,4.14,0,0,1-1.5-1.7,3.64,3.64,0,0,1-.33-2,4,4,0,0,1,.64-1.67,4.07,4.07,0,0,1,2-1.59,3,3,0,0,1,.39-.11,1.18,1.18,0,0,1,.29-.05A.62.62,0,0,1,105,215.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.76,224.82s-.21.05-.54.2a2.57,2.57,0,0,0-1.15,1,2.17,2.17,0,0,0-.14,2.14,2.27,2.27,0,0,0,4.25-.25,2.16,2.16,0,0,0-.39-2.11,2.56,2.56,0,0,0-1.26-.86c-.35-.11-.56-.1-.56-.13a1.17,1.17,0,0,1,.59,0,2.62,2.62,0,0,1,1.92,1.85,2.35,2.35,0,0,1,0,1.31,2.52,2.52,0,0,1-4.73.28,2.22,2.22,0,0,1-.21-1.3,2.51,2.51,0,0,1,.41-1.06,2.57,2.57,0,0,1,1.28-1A1.23,1.23,0,0,1,114.76,224.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.42,195.33s0-.17,0-.5,0-.83,0-1.47c0-.33,0-.69,0-1.09s-.06-.83-.09-1.3-.07-1-.12-1.52a4.85,4.85,0,0,0-.11-.83l-.15-.88a29.65,29.65,0,0,0-2.77-8.45A30.74,30.74,0,0,0,93.09,170l-1.25-1.09c-.44-.34-.91-.66-1.37-1l-.71-.5a4.3,4.3,0,0,0-.72-.48L87.5,166c-.26-.15-.51-.31-.78-.45l-.83-.38-1.67-.76c-.58-.24-1.18-.42-1.77-.63l-.9-.31-.46-.15-.47-.11a30,30,0,0,0-3.84-.75c-.66-.07-1.33-.19-2-.23l-2-.06c-.34,0-.68,0-1,0l-1,.08c-.7.06-1.4.08-2.09.17a32.54,32.54,0,0,0-4.19.88l-1.05.3c-.17,0-.35.09-.52.15l-.51.2-2.06.8c-.67.3-1.33.66-2,1-.33.18-.67.32-1,.52l-1,.61a33.91,33.91,0,0,0-3.71,2.69l-1.69,1.59-.43.4-.39.44-.77.89-.78.88-.7,1-.69,1-.35.49c-.11.17-.21.34-.31.51l-1.21,2.09c-.33.73-.67,1.46-1,2.2a30.45,30.45,0,0,0-1.51,19.36l.66,2.34.87,2.24.22.56.27.53.54,1.07.53,1.05.64,1,.63,1,.31.49.36.46,1.43,1.84a34.15,34.15,0,0,0,3.25,3.23l.85.75c.28.25.6.45.9.67.61.43,1.2.89,1.82,1.29L58,220l.47.28.5.23,1,.45a33.08,33.08,0,0,0,4,1.52c.68.2,1.37.33,2,.5l1,.24c.34.07.68.09,1,.14l2,.26c.67.07,1.34,0,2,.08a28.26,28.26,0,0,0,3.92-.14l.48,0,.47-.08.94-.16c.62-.12,1.24-.2,1.84-.35l1.78-.49.88-.24.84-.33,1.65-.64a5.15,5.15,0,0,0,.79-.36l.78-.39c.51-.26,1-.5,1.51-.77l1.4-.89a30.53,30.53,0,0,0,8.49-8.11c.25-.35.51-.69.75-1l.62-1.06.6-1c.1-.17.2-.33.29-.5s.15-.35.23-.52l.9-1.94c.26-.62.44-1.25.65-1.82l.3-.85a5.11,5.11,0,0,0,.23-.8l.36-1.49c.1-.46.22-.88.29-1.27s.1-.75.15-1.07c.08-.64.15-1.12.2-1.46s.08-.49.08-.49,0,.17,0,.5l-.18,1.46c0,.32-.08.68-.13,1.07s-.18.82-.28,1.28-.22,1-.34,1.49a4.92,4.92,0,0,1-.23.81c-.1.28-.19.56-.29.85-.21.58-.38,1.21-.65,1.84s-.58,1.27-.88,2l-.24.52c-.08.17-.19.34-.28.51-.2.33-.4.68-.6,1s-.41.71-.62,1.08-.5.69-.75,1.05A30.66,30.66,0,0,1,89.39,219l-1.41.9c-.49.27-1,.52-1.52.78l-.77.4a5.75,5.75,0,0,1-.8.36l-1.67.65-.84.33-.88.25-1.79.5c-.61.15-1.24.23-1.86.35l-.95.17-.47.08-.49,0a28.53,28.53,0,0,1-3.94.16c-.67,0-1.35,0-2-.08l-2-.26c-.35,0-.69-.07-1-.15l-1-.23c-.68-.17-1.38-.3-2.06-.5a30.83,30.83,0,0,1-4-1.53l-1-.45-.5-.23-.48-.28-1.93-1.12c-.62-.4-1.22-.87-1.83-1.3-.31-.23-.63-.43-.91-.68l-.86-.75A33.63,33.63,0,0,1,49,213.09l-1.45-1.85-.36-.47-.32-.5-.63-1-.64-1-.54-1.06-.55-1.08-.27-.54L44,205c-.3-.75-.59-1.51-.88-2.26s-.44-1.57-.67-2.36A30.81,30.81,0,0,1,44,180.86l1-2.23c.41-.7.82-1.4,1.22-2.1.11-.17.2-.35.31-.52l.35-.49.71-1,.7-1,.79-.9.78-.89.39-.44.43-.41,1.71-1.61a33.51,33.51,0,0,1,3.75-2.7l1-.61c.32-.21.67-.35,1-.53.67-.33,1.33-.7,2-1l2.08-.81.52-.2.52-.15,1.06-.29a31.67,31.67,0,0,1,4.22-.88c.71-.09,1.41-.12,2.11-.18l1-.07c.34,0,.69,0,1,0l2.06.06c.68,0,1.34.16,2,.24a27,27,0,0,1,3.87.77l.48.11c.15,0,.3.1.45.15l.91.31c.6.22,1.21.39,1.78.63L86,165l.83.38.79.45,1.54.9a6.2,6.2,0,0,1,.73.49l.71.51c.46.34.94.66,1.38,1l1.26,1.1a30.84,30.84,0,0,1,7.13,9.41,29.22,29.22,0,0,1,2.74,8.5c.05.3.1.6.15.88a6.39,6.39,0,0,1,.1.84c0,.54.08,1.05.11,1.52s.07.91.08,1.31,0,.76,0,1.09c0,.64,0,1.13,0,1.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sreen--inject-4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 237.76,
    y: 47.12,
    width: 206.45,
    height: 313.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.34,
    y: 63.08,
    width: 206.51,
    height: 134.87,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.79,217V220h4.41v1.08h-4.41v3.56h-1.26v-8.8h6.22V217Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.51,221.34a3.47,3.47,0,1,1,3.47,3.41A3.32,3.32,0,0,1,293.51,221.34Zm5.71,0a2.25,2.25,0,1,0-2.24,2.35A2.19,2.19,0,0,0,299.22,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.7,217.94v1.17h-.28a2,2,0,0,0-2.1,2.25v3.32h-1.21V218h1.16v1.11A2.57,2.57,0,0,1,305.7,217.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.49,218v5.75c0,2.36-1.19,3.42-3.45,3.42a4.88,4.88,0,0,1-3.18-1l.57-.93a4.08,4.08,0,0,0,2.57.87c1.57,0,2.29-.73,2.29-2.24v-.53a3.06,3.06,0,0,1-2.4,1,3.23,3.23,0,1,1,0-6.45,3,3,0,0,1,2.46,1.1v-1Zm-1.18,3.15a2.3,2.3,0,0,0-4.59,0,2.3,2.3,0,0,0,4.59,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.18,221.34a3.47,3.47,0,1,1,3.47,3.41A3.32,3.32,0,0,1,315.18,221.34Zm5.71,0a2.25,2.25,0,1,0-2.24,2.35A2.19,2.19,0,0,0,320.89,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.53,224.28a2.32,2.32,0,0,1-1.46.47,1.9,1.9,0,0,1-2.11-2.09V219h-1.14v-1H324v-1.46h1.2V218h1.91v1h-1.91v3.61a1,1,0,0,0,1,1.12,1.52,1.52,0,0,0,.94-.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.27,221.34a3.24,3.24,0,0,1-3.37,3.41,2.83,2.83,0,0,1-2.32-1.09v3.45h-1.21V218h1.16v1.05a2.83,2.83,0,0,1,2.37-1.12A3.24,3.24,0,0,1,339.27,221.34Zm-1.22,0a2.25,2.25,0,1,0-2.25,2.35A2.2,2.2,0,0,0,338.05,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.16,220.65v4H345v-.88a2.49,2.49,0,0,1-2.19,1c-1.51,0-2.46-.81-2.46-2s.69-1.95,2.67-1.95H345v-.23c0-1-.6-1.61-1.79-1.61a3.35,3.35,0,0,0-2.11.71l-.5-.9a4.38,4.38,0,0,1,2.75-.86C345.13,217.94,346.16,218.82,346.16,220.65Zm-1.2,2v-.93H343.1c-1.2,0-1.54.47-1.54,1s.55,1.08,1.47,1.08A1.94,1.94,0,0,0,345,222.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.56,224l.5-1a4.31,4.31,0,0,0,2.34.69c1.12,0,1.58-.34,1.58-.9,0-1.5-4.21-.2-4.21-2.86,0-1.19,1.07-2,2.78-2a4.83,4.83,0,0,1,2.43.61l-.52.95a3.47,3.47,0,0,0-1.92-.53c-1.06,0-1.57.39-1.57.92,0,1.57,4.22.29,4.22,2.88,0,1.21-1.1,2-2.88,2A4.81,4.81,0,0,1,347.56,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.86,224l.5-1a4.31,4.31,0,0,0,2.34.69c1.12,0,1.58-.34,1.58-.9,0-1.5-4.21-.2-4.21-2.86,0-1.19,1.07-2,2.78-2a4.83,4.83,0,0,1,2.43.61l-.52.95a3.47,3.47,0,0,0-1.92-.53c-1.06,0-1.57.39-1.57.92,0,1.57,4.22.29,4.22,2.88,0,1.21-1.1,2-2.88,2A4.81,4.81,0,0,1,353.86,224Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,218l-2.49,6.66h-1.16l-1.92-5-1.95,5h-1.16L359.81,218H361l1.94,5.3,2-5.3h1l2,5.33,2-5.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.38,221.34a3.46,3.46,0,1,1,3.47,3.41A3.32,3.32,0,0,1,371.38,221.34Zm5.7,0a2.24,2.24,0,1,0-2.23,2.35A2.18,2.18,0,0,0,377.08,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.56,217.94v1.17h-.28a2,2,0,0,0-2.1,2.25v3.32H380V218h1.15v1.11A2.57,2.57,0,0,1,383.56,217.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.27,215.34v9.33h-1.16v-1.06a2.81,2.81,0,0,1-2.38,1.14,3.41,3.41,0,0,1,0-6.81,2.85,2.85,0,0,1,2.33,1.07v-3.67Zm-1.2,6a2.25,2.25,0,1,0-2.24,2.35A2.19,2.19,0,0,0,390.07,221.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.49,218.19c0-.8-.66-1.35-1.8-1.35a2.7,2.7,0,0,0-2.25,1l-.91-.65a3.88,3.88,0,0,1,3.25-1.41c1.81,0,3,.84,3,2.24,0,2.1-2.22,2.23-2.22,3.88h-1.26C395.28,219.92,397.49,219.64,397.49,218.19Zm-2.39,5.75a.82.82,0,0,1,1.63,0,.82.82,0,0,1-1.63,0Z",
    style: {
      fill: "#263238"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M422.61,242.73c0,.15-35.38.26-79,.26s-79-.11-79-.26,35.37-.26,79-.26S422.61,242.59,422.61,242.73Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M388.88,251.18c0,.14-20.27.26-45.28.26s-45.29-.12-45.29-.26,20.28-.26,45.29-.26S388.88,251,388.88,251.18Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,144.09a24.08,24.08,0,1,0-37.36-5.71l-4.9,4.57,1.18,8.13L325.91,149l-6.13,5.72L321,162.8l-7.6-2.13-5.27,4.91.72,5-4.64-1.3-3.06,2.86-.46,7.53,11.23,2.83,36.45-34A24.09,24.09,0,0,0,374.6,144.09ZM371,114.48a6.91,6.91,0,1,1-9.76-.34A6.91,6.91,0,0,1,371,114.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,144.09a24.08,24.08,0,1,0-37.36-5.71l-4.9,4.57,1.18,8.13L325.91,149l-6.13,5.72L321,162.8l-7.6-2.13-5.27,4.91.72,5-4.64-1.3-3.06,2.86-.46,7.53,11.23,2.83,36.45-34A24.09,24.09,0,0,0,374.6,144.09ZM371,114.48a6.91,6.91,0,1,1-9.76-.34A6.91,6.91,0,0,1,371,114.48Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371,114.48s-.45-.42-1.37-1a7,7,0,0,0-4.35-.95,6.65,6.65,0,1,0,7.26,7.78,6.86,6.86,0,0,0-.65-4.4c-.5-1-.94-1.4-.89-1.44s.13.09.33.3a5.53,5.53,0,0,1,.77,1,6.85,6.85,0,0,1,.86,4.58,7.11,7.11,0,0,1-8.35,5.87,7.13,7.13,0,0,1-5.8-6.22,7.11,7.11,0,0,1,6.43-7.92,6.86,6.86,0,0,1,4.52,1.18,5.34,5.34,0,0,1,1,.83C371,114.35,371.06,114.47,371,114.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.6,144.09s-.11.12-.35.33l-1.06,1a24.92,24.92,0,0,1-4.66,3,24.21,24.21,0,0,1-20.29.29l.2,0-36.39,34.06-.1.11-.15,0-11.23-2.82-.23-.05,0-.24c.14-2.35.29-4.92.45-7.53V172l.08-.08L304,169l.11-.11.16,0,4.64,1.3-.37.32c-.23-1.55-.47-3.25-.72-5l0-.15.11-.1,5.27-4.92.12-.12.16,0,7.6,2.13-.37.33c-.37-2.58-.77-5.34-1.17-8.13l0-.16.12-.1,1.62-1.52,4.51-4.2.12-.12.16,0,7.61,2.13-.38.33q-.59-4.11-1.17-8.13l0-.15.11-.11,4.9-4.57-.05.36a24.51,24.51,0,0,1-3.13-11,23,23,0,0,1,.4-5.57,23.55,23.55,0,0,1,1.6-5.24,24.3,24.3,0,0,1,44.07-1,24.14,24.14,0,0,1,2.37,12.64,23.67,23.67,0,0,1-2.7,9.27c-.15.3-.3.58-.45.86l-.49.76c-.33.49-.6,1-.92,1.37-.65.78-1.15,1.48-1.64,2L375,143.73l-.39.36s.11-.14.35-.4l1.08-1.15c.47-.5,1-1.21,1.59-2,.3-.41.56-.89.88-1.37.16-.25.32-.5.48-.77l.44-.85A23.87,23.87,0,1,0,336.37,117a23.53,23.53,0,0,0-1.56,5.12,23,23,0,0,0-.38,5.44,24,24,0,0,0,3.07,10.7l.11.2-.17.16-4.89,4.57.09-.26q.58,4,1.17,8.14l.07.45-.45-.12-7.6-2.13.29-.07-4.51,4.2L320,154.89l.09-.27c.4,2.79.8,5.56,1.17,8.13l.07.46-.45-.12-7.6-2.14.28-.07c-1.81,1.7-3.61,3.37-5.27,4.92l.1-.26c.24,1.71.48,3.41.71,5l.06.44-.43-.12-4.63-1.3.27-.07-3.07,2.86.09-.19c-.16,2.61-.32,5.18-.46,7.53l-.21-.29,11.23,2.83-.25.07,36.5-33.94.09-.08.11,0a24.07,24.07,0,0,0,20.06-.14,26.43,26.43,0,0,0,4.68-2.86l1.09-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,141.36a24.07,24.07,0,1,0-37.35-5.72h0l-4.89,4.56,1.17,8.14-7.6-2.14L319,151.93l1.17,8.13-7.6-2.13-5.27,4.92.71,5-4.63-1.29-3.07,2.86-.46,7.53,11.23,2.82,36.45-34A24.06,24.06,0,0,0,373.79,141.36Zm-3.56-29.61a6.91,6.91,0,1,1-9.76-.34A6.9,6.9,0,0,1,370.23,111.75Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,141.36a24.07,24.07,0,1,0-37.35-5.72h0l-4.89,4.56,1.17,8.14-7.6-2.14L319,151.93l1.17,8.13-7.6-2.13-5.27,4.92.71,5-4.63-1.29-3.07,2.86-.46,7.53,11.23,2.82,36.45-34A24.06,24.06,0,0,0,373.79,141.36Zm-3.56-29.61a6.91,6.91,0,1,1-9.76-.34A6.9,6.9,0,0,1,370.23,111.75Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.23,111.75s-.45-.42-1.37-1a6.85,6.85,0,0,0-4.34-1,6.64,6.64,0,1,0,7.26,7.78,6.85,6.85,0,0,0-.66-4.4c-.5-1-.93-1.4-.89-1.44s.13.09.34.3a5.54,5.54,0,0,1,.76,1,6.84,6.84,0,0,1,.86,4.59,7.12,7.12,0,0,1-8.34,5.87A7.12,7.12,0,0,1,358,117.3a7.13,7.13,0,0,1,6.43-7.92,6.85,6.85,0,0,1,4.52,1.19,5,5,0,0,1,1,.83C370.16,111.62,370.25,111.74,370.23,111.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.79,141.36s-.11.12-.34.33l-1.06.94a25.39,25.39,0,0,1-4.66,3,24.24,24.24,0,0,1-20.3.29l.2,0-36.38,34.06-.11.1-.14,0-11.24-2.82-.22-.06v-.23c.14-2.35.3-4.92.45-7.53v-.12l.08-.07,3.07-2.87.12-.11.16,0,4.63,1.29-.37.33c-.22-1.55-.47-3.25-.72-5l0-.15.12-.11,5.26-4.91.12-.12.17.05,7.6,2.13-.38.33L318.68,152l0-.16.11-.11,1.63-1.51,4.5-4.2.12-.12.17.05,7.6,2.13-.38.33q-.59-4.11-1.17-8.13l0-.16.12-.1,4.9-4.57-.06.36a24.51,24.51,0,0,1-3.13-11,23.5,23.5,0,0,1,.4-5.57,23.75,23.75,0,0,1,1.6-5.24,24.25,24.25,0,0,1,46.44,11.63,23.72,23.72,0,0,1-2.7,9.27l-.45.86-.49.76c-.33.49-.6,1-.91,1.37-.65.78-1.15,1.48-1.64,2L374.18,141c-.25.25-.39.37-.39.37s.12-.15.36-.41l1.07-1.14c.47-.5,1-1.21,1.59-2,.3-.4.57-.88.89-1.37l.48-.76.43-.86a23.69,23.69,0,0,0,2.59-9.19,23.86,23.86,0,0,0-45.64-11.39,23.5,23.5,0,0,0-1.55,5.12,22.45,22.45,0,0,0-.38,5.44,24,24,0,0,0,3.06,10.7l.12.2-.17.16-4.9,4.57.09-.26q.59,4,1.17,8.13l.07.46-.44-.13L325,146.5l.28-.07-4.5,4.21-1.63,1.51.09-.26c.41,2.79.8,5.55,1.17,8.13l.07.46-.44-.13-7.61-2.13.29-.07-5.27,4.91.09-.25c.24,1.71.49,3.4.71,4.95l.06.45-.43-.12-4.63-1.3.27-.07-3.06,2.86.09-.2c-.16,2.61-.32,5.19-.47,7.53l-.21-.29,11.23,2.84-.25.07,36.5-33.94.09-.08.11.05a24.18,24.18,0,0,0,20.06-.14,26.81,26.81,0,0,0,4.69-2.86l1.08-.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.58,139.48a32.5,32.5,0,0,0,3.24-4.08,20.24,20.24,0,0,0,2.47-5.54,21.14,21.14,0,0,0,.69-8,20.85,20.85,0,0,0-3.17-9.12,21.1,21.1,0,0,0-8.18-7.4,19.5,19.5,0,0,0-5.69-1.92,22.66,22.66,0,0,0-3.09-.36,24.13,24.13,0,0,0-3.17.16,20.79,20.79,0,0,0-18.07,16.85,24,24,0,0,0-.38,3.15,22.9,22.9,0,0,0,.15,3.11,19.37,19.37,0,0,0,1.52,5.81,21,21,0,0,0,6.82,8.67,20.7,20.7,0,0,0,8.87,3.8,21,21,0,0,0,8-.13,20.44,20.44,0,0,0,5.7-2.09,31.88,31.88,0,0,0,4.29-2.94s-.07.09-.24.24l-.75.68a9.87,9.87,0,0,1-1.29,1,14.63,14.63,0,0,1-1.9,1.22,20.23,20.23,0,0,1-5.74,2.21,21.33,21.33,0,0,1-24.27-12.45,20.08,20.08,0,0,1-1.58-6A19.37,19.37,0,0,1,336,120a21.34,21.34,0,0,1,18.58-17.33,19.92,19.92,0,0,1,6.43.22,20.36,20.36,0,0,1,5.84,2,21.49,21.49,0,0,1,8.35,7.63A21.45,21.45,0,0,1,377.62,130a20,20,0,0,1-2.61,5.58,13.58,13.58,0,0,1-1.34,1.8,10.08,10.08,0,0,1-1.1,1.22l-.73.7C371.68,139.41,371.59,139.49,371.58,139.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.61,122.39c-.05,0,.5-.52,1.17-1.59a8,8,0,0,0,1.14-5.11,7.81,7.81,0,0,0-4.29-6.17,7.72,7.72,0,0,0-4.46-.79,7.83,7.83,0,0,0-6.28,10.81,8.06,8.06,0,0,0,2.54,3.25,8,8,0,0,0,3.32,1.45,8,8,0,0,0,5.18-.79c1.12-.59,1.63-1.11,1.68-1.06s-.11.15-.36.38a6,6,0,0,1-1.21.89,8.16,8.16,0,0,1-8.9-.47,8.32,8.32,0,0,1-3.3-8.28,8.31,8.31,0,0,1,7.26-6.76,8.24,8.24,0,0,1,4.79.87,8.39,8.39,0,0,1,3.24,3,8.21,8.21,0,0,1-.15,8.91,6.3,6.3,0,0,1-1,1.14C370.76,122.3,370.62,122.41,370.61,122.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.12,178.39c-.11-.12,8.09-8,18.33-17.51s18.63-17.19,18.74-17.07-8.09,8-18.33,17.51S308.23,178.51,308.12,178.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.64,130.67l.34-.74.44.68a3.44,3.44,0,0,0,1.46,1.24l.75.33-.68.45a3.41,3.41,0,0,0-1.25,1.46l-.33.74-.45-.68a3.4,3.4,0,0,0-1.46-1.24l-.74-.33.68-.45A3.32,3.32,0,0,0,312.64,130.67Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.33,125.11l.19-.43.26.39a1.92,1.92,0,0,0,.85.72l.43.2-.4.26a2,2,0,0,0-.72.84l-.19.44-.26-.4a1.92,1.92,0,0,0-.85-.72l-.43-.2.39-.25A2.07,2.07,0,0,0,290.33,125.11Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.6,163.14l.19-.43.26.4a2.12,2.12,0,0,0,.85.72l.43.19-.39.26a1.92,1.92,0,0,0-.72.85l-.2.43-.26-.39a2,2,0,0,0-.84-.73l-.44-.19.4-.26A1.92,1.92,0,0,0,360.6,163.14Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,143.64l.33-.74.45.68a3.39,3.39,0,0,0,1.46,1.24l.74.33-.68.45a3.38,3.38,0,0,0-1.24,1.46l-.34.74-.44-.68a3.51,3.51,0,0,0-1.46-1.24l-.75-.33.68-.45A3.41,3.41,0,0,0,395,143.64Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.53,116.32l.56-1.25.75,1.15a5.79,5.79,0,0,0,2.45,2.09l1.25.55-1.15.75a5.87,5.87,0,0,0-2.09,2.46l-.56,1.25-.75-1.15a5.79,5.79,0,0,0-2.45-2.09l-1.25-.56,1.15-.75A5.79,5.79,0,0,0,390.53,116.32Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.71,107.9l.56-1.25.75,1.14a5.72,5.72,0,0,0,2.45,2.09l1.25.56-1.14.75a5.65,5.65,0,0,0-2.09,2.45l-.56,1.25-.75-1.14a5.69,5.69,0,0,0-2.46-2.09l-1.24-.56,1.14-.75A5.72,5.72,0,0,0,305.71,107.9Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.88,298.31s.32,0,.94-.08a6.11,6.11,0,0,0,1.16-.13l.73-.12.83-.22a13.42,13.42,0,0,0,4.08-1.82,14.36,14.36,0,0,0,5.8-7.6,14.25,14.25,0,0,0,.66-3.94c0-.7,0-1.43,0-2.15l-.06-1.1c0-.37-.11-.74-.17-1.11a14.64,14.64,0,0,0-1.59-4.41,14.19,14.19,0,0,0-7.87-6.48,16,16,0,0,0-5.61-.74h-6.06l-129.39.08a14.12,14.12,0,0,0-8.6,2.93,14.89,14.89,0,0,0-3.12,3.32,14.18,14.18,0,0,0-1.87,4.12,15.53,15.53,0,0,0-.43,2.22c0,.75-.1,1.5-.08,2.27a15,15,0,0,0,.54,4.44,14.69,14.69,0,0,0,1.85,4,15.21,15.21,0,0,0,3,3.21,13.68,13.68,0,0,0,3.8,2.13,15.3,15.3,0,0,0,2.07.61,15.74,15.74,0,0,0,2.15.25c2.89.07,5.81,0,8.67,0h16.81l58.17.05,39.22.09,10.66.05,2.78,0,.94,0s-.32,0-.94,0l-2.78,0-10.66.05-39.22.08-58.17.06H283.3c-2.87,0-5.75,0-8.7,0a16.76,16.76,0,0,1-2.22-.25,16.09,16.09,0,0,1-2.15-.64,14,14,0,0,1-3.93-2.2,14.39,14.39,0,0,1-5-7.49,15.76,15.76,0,0,1-.56-4.58c0-.76,0-1.55.08-2.32a16.4,16.4,0,0,1,.45-2.3,14.89,14.89,0,0,1,1.94-4.28,15.11,15.11,0,0,1,3.24-3.44,14.61,14.61,0,0,1,8.91-3l129.39.07h6.06a16.74,16.74,0,0,1,5.72.77,14.55,14.55,0,0,1,8,6.65,14.81,14.81,0,0,1,1.61,4.51l.17,1.13c0,.38,0,.75,0,1.12,0,.74,0,1.45,0,2.17a14.69,14.69,0,0,1-.69,4,15,15,0,0,1-1.59,3.32,14.2,14.2,0,0,1-4.34,4.34,13.78,13.78,0,0,1-4.14,1.8l-.84.2-.74.11a6.85,6.85,0,0,1-1.16.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 260.97,
    y: 304.74,
    width: 165.26,
    height: 30.07,
    rx: 14.35,
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,289.27a6.76,6.76,0,0,1,0-.89c0-.62,0-1.43-.05-2.43,0-2.14-.06-5.1-.11-8.67l.21.2-17.87.06.26-.26h0v3.14c0,1,0,2.06,0,3.06,0,2,0,3.94,0,5.77l-.24-.24,12.81.12,3.7.06,1,0,.36,0a9.6,9.6,0,0,1-1.26.06l-3.65.06-13,.12H276v-.24c0-1.83,0-3.76,0-5.77,0-1,0-2,0-3.06V277.3h0c-.23.23.32-.32.26-.27l17.87.06h.21v.21c-.05,3.63-.09,6.63-.11,8.8,0,1,0,1.78-.06,2.39A5.74,5.74,0,0,1,294.15,289.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,277.28a23.64,23.64,0,0,1-2.5,2.4c-1.58,1.44-3.8,3.39-6.26,5.53H285v0l0,0-.06-.05-.12-.1-.23-.2-.45-.39-.88-.77-1.67-1.47-2.8-2.5a23.64,23.64,0,0,1-2.5-2.4A21.9,21.9,0,0,1,279,279.4l2.87,2.42,1.69,1.44.89.76.46.4.22.2.12.09.06.05,0,0H285c2.47-2.13,4.72-4,6.37-5.41A21.9,21.9,0,0,1,294.15,277.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.73,282.86a19.29,19.29,0,0,1-3,3.39,20.16,20.16,0,0,1-3.41,3,20.24,20.24,0,0,1,3-3.39A20.61,20.61,0,0,1,282.73,282.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,289.27a19.58,19.58,0,0,1-3.21-3.22,20.47,20.47,0,0,1-2.82-3.56,20.13,20.13,0,0,1,3.21,3.22A19.9,19.9,0,0,1,294.15,289.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.94,285.67v.4h-4.15v-6h4v.4h-3.58v2.37h3.2v.39h-3.2v2.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.77,283.45v2.62h-.43v-2.59c0-1-.53-1.55-1.4-1.55a1.58,1.58,0,0,0-1.64,1.75v2.39h-.43v-2.59c0-1-.53-1.55-1.4-1.55a1.58,1.58,0,0,0-1.64,1.75v2.39h-.43v-4.49h.41v1a1.78,1.78,0,0,1,1.72-1,1.59,1.59,0,0,1,1.64,1.08,1.89,1.89,0,0,1,1.81-1.08A1.68,1.68,0,0,1,313.77,283.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.77,283.22v2.85h-.41v-.8a1.75,1.75,0,0,1-1.62.83c-1,0-1.61-.51-1.61-1.28s.43-1.25,1.67-1.25h1.54v-.36a1.17,1.17,0,0,0-1.33-1.28,2.36,2.36,0,0,0-1.55.56l-.21-.31a2.74,2.74,0,0,1,1.79-.63A1.52,1.52,0,0,1,318.77,283.22Zm-.43,1.52v-.84h-1.53c-.93,0-1.25.39-1.25.9s.45.95,1.24.95A1.54,1.54,0,0,0,318.34,284.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.4,280.15a.35.35,0,0,1,.35-.35.35.35,0,1,1-.35.35Zm.13,1.43H321v4.49h-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.77,279.69h.43v6.38h-.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.67,323.81l-1.62-2.27a4.77,4.77,0,0,1-.66,0h-1.94v2.22H306V317h2.43c1.7,0,2.73.85,2.73,2.29a2.08,2.08,0,0,1-1.59,2.12l1.7,2.37Zm-2.28-2.65c1.45,0,2.23-.68,2.23-1.84s-.78-1.85-2.23-1.85h-1.94v3.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.05,321.4H312.7a2,2,0,0,0,2.14,2,2.06,2.06,0,0,0,1.62-.7l.28.32a2.41,2.41,0,0,1-1.91.82,2.48,2.48,0,0,1-2.6-2.57,2.42,2.42,0,1,1,4.83,0S317.05,321.35,317.05,321.4Zm-4.34-.38h3.88a1.94,1.94,0,0,0-3.88,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.82,323.2l.22-.39a3,3,0,0,0,1.82.61c1.07,0,1.5-.37,1.5-.95,0-1.47-3.36-.38-3.36-2.37,0-.76.64-1.38,1.92-1.38a3.13,3.13,0,0,1,1.74.49l-.23.39a2.6,2.6,0,0,0-1.52-.46c-1,0-1.42.41-1.42.95,0,1.52,3.35.45,3.35,2.38,0,.82-.71,1.38-2,1.38A3.16,3.16,0,0,1,317.82,323.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.47,321.4h-4.35a2,2,0,0,0,2.14,2,2.06,2.06,0,0,0,1.62-.7l.28.32a2.43,2.43,0,0,1-1.91.82,2.49,2.49,0,0,1-2.61-2.57,2.42,2.42,0,0,1,2.43-2.56,2.39,2.39,0,0,1,2.41,2.54S327.47,321.35,327.47,321.4Zm-4.34-.38H327a1.94,1.94,0,0,0-3.87,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.49,323.49a1.55,1.55,0,0,1-1,.36,1.25,1.25,0,0,1-1.37-1.38v-3.3h-.93v-.42h.93v-1.1h.48v1.1h1.61v.42h-1.61v3.26c0,.65.32,1,.94,1a1.16,1.16,0,0,0,.79-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.65,319.32c0,1.42-1,2.27-2.73,2.27H336v2.22h-.5V317h2.44C339.62,317,340.65,317.88,340.65,319.32Zm-.5,0c0-1.18-.78-1.85-2.23-1.85H336v3.68h1.94C339.37,321.15,340.15,320.48,340.15,319.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.77,320.6v3.21h-.47v-.9a1.94,1.94,0,0,1-1.82.94c-1.13,0-1.82-.58-1.82-1.44s.48-1.42,1.89-1.42h1.73v-.4a1.32,1.32,0,0,0-1.5-1.45,2.63,2.63,0,0,0-1.75.64l-.24-.35a3.13,3.13,0,0,1,2-.71A1.72,1.72,0,0,1,345.77,320.6Zm-.49,1.72v-.95h-1.72c-1.05,0-1.42.44-1.42,1s.51,1.06,1.41,1.06A1.72,1.72,0,0,0,345.28,322.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347,323.2l.22-.39a2.93,2.93,0,0,0,1.82.61c1.07,0,1.49-.37,1.49-.95,0-1.47-3.35-.38-3.35-2.37,0-.76.64-1.38,1.92-1.38a3.07,3.07,0,0,1,1.73.49l-.22.39a2.62,2.62,0,0,0-1.52-.46c-1,0-1.43.41-1.43.95,0,1.52,3.36.45,3.36,2.38,0,.82-.71,1.38-2,1.38A3.14,3.14,0,0,1,347,323.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.65,323.2l.22-.39a3,3,0,0,0,1.82.61c1.07,0,1.5-.37,1.5-.95,0-1.47-3.36-.38-3.36-2.37,0-.76.64-1.38,1.92-1.38a3.13,3.13,0,0,1,1.74.49l-.23.39a2.6,2.6,0,0,0-1.52-.46c-1,0-1.42.41-1.42.95,0,1.52,3.35.45,3.35,2.38,0,.82-.71,1.38-2,1.38A3.16,3.16,0,0,1,351.65,323.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.16,318.75l-1.92,5.06h-.46l-1.7-4.39-1.72,4.39h-.44L356,318.75h.46l1.69,4.52,1.73-4.52h.41l1.72,4.51,1.7-4.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.59,321.28a2.53,2.53,0,1,1,2.52,2.57A2.45,2.45,0,0,1,364.59,321.28Zm4.56,0a2,2,0,1,0-2,2.13A2,2,0,0,0,369.15,321.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.54,318.72v.47h-.12c-1.12,0-1.79.75-1.79,2v2.63h-.48v-5.06h.46v1.11A1.92,1.92,0,0,1,373.54,318.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.32,316.62v7.19h-.47v-1.19a2.25,2.25,0,0,1-2.07,1.23,2.57,2.57,0,0,1,0-5.13,2.26,2.26,0,0,1,2.06,1.21v-3.31Zm-.48,4.66a2,2,0,1,0-2,2.13A2,2,0,0,0,378.84,321.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.84,63.08c0,.14-46.23.26-103.25.26s-103.25-.12-103.25-.26,46.22-.26,103.25-.26S443.84,62.94,443.84,63.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249,54.88a2.51,2.51,0,1,1-2.51-2.52A2.51,2.51,0,0,1,249,54.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.26,54.88a2.51,2.51,0,1,1-2.51-2.52A2.51,2.51,0,0,1,256.26,54.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.48,54.88A2.51,2.51,0,1,1,261,52.36,2.51,2.51,0,0,1,263.48,54.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.21,360.5c0-2.14-.1-128.94-.24-313.38l.24.24-206.79,0h0l.26-.26c0,118.26,0,227.29-.06,313.38l-.2-.2,206.81.2-206.81.21h-.21v-.21c0-86.09,0-195.12-.05-313.38v-.26h.28l206.79,0h.24v.24C444.31,231.56,444.21,358.37,444.21,360.5Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.43,445a2.94,2.94,0,0,0-.17-.41c-.14-.29-.32-.67-.55-1.17a28.83,28.83,0,0,1-1.61-4.69,41.43,41.43,0,0,1,.13-18.1,99,99,0,0,1,3.36-12.17c1.42-4.31,3.08-8.89,4.42-13.84a53.54,53.54,0,0,0,2.19-15.93c-.21-5.63-1.87-11.25-3.71-16.85s-3.72-11.08-4.29-16.59a25.32,25.32,0,0,1,3-15.32c2.43-4.47,5.48-8.3,7.77-12.26a42.86,42.86,0,0,0,4.67-11.78,44,44,0,0,0,.29-18.26,34.32,34.32,0,0,0-1.9-6.45,2.5,2.5,0,0,0,.11.43c.1.31.22.72.39,1.24a48,48,0,0,1,1.18,4.82,44.43,44.43,0,0,1-.47,18.12,42.23,42.23,0,0,1-4.69,11.64c-2.28,3.91-5.34,7.72-7.82,12.24a25.75,25.75,0,0,0-3.13,15.64c.57,5.6,2.47,11.12,4.3,16.71s3.48,11.16,3.69,16.69a53.28,53.28,0,0,1-2.13,15.76c-1.33,4.93-3,9.51-4.37,13.84a96.41,96.41,0,0,0-3.3,12.24c-1.54,7.62-1.1,14.06.05,18.24a27.56,27.56,0,0,0,1.72,4.68l.61,1.15A2.09,2.09,0,0,0,440.43,445Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.91,321.54s4.64-14.84-3.69-23.53a.51.51,0,0,0-.88.26C442.9,300.72,442.34,308.18,447.91,321.54Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.13,303a13.27,13.27,0,0,0,.31,2.74c.3,1.89.66,4.1,1.06,6.55s.74,4.66,1,6.54a13.94,13.94,0,0,0,.49,2.71,11.5,11.5,0,0,0-.09-2.76c-.15-1.69-.45-4-.87-6.59s-.86-4.86-1.23-6.52A12.73,12.73,0,0,0,445.13,303Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.46,356.53s-2.84-15.28-14.26-19.07a.52.52,0,0,0-.66.64C428.29,340.47,431.29,347.33,442.46,356.53Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.31,341.41a13.74,13.74,0,0,0,1.55,2.27l4,5.29c1.49,2,2.83,3.78,4,5.3a16.26,16.26,0,0,0,1.7,2.17,12,12,0,0,0-1.36-2.4c-.93-1.43-2.29-3.35-3.86-5.42s-3-3.89-4.13-5.19A12.66,12.66,0,0,0,431.31,341.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.54,394.88s1.73-15.45-8.1-22.39a.52.52,0,0,0-.82.42C436.65,375.4,437.53,382.83,445.54,394.88Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.27,377.17a12.77,12.77,0,0,0,.83,2.63c.66,1.79,1.43,3.9,2.28,6.22s1.62,4.43,2.27,6.23a14.51,14.51,0,0,0,1,2.56,11.24,11.24,0,0,0-.61-2.69c-.47-1.63-1.21-3.87-2.11-6.3s-1.78-4.61-2.45-6.17A12.71,12.71,0,0,0,439.27,377.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.94,433.46s1.17-15.51-8.9-22.09a.51.51,0,0,0-.8.45C427.36,414.3,428.5,421.7,436.94,433.46Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430,416a14.65,14.65,0,0,0,.93,2.6c.72,1.77,1.57,3.84,2.51,6.13s1.77,4.38,2.49,6.14a13.32,13.32,0,0,0,1.09,2.53,11.92,11.92,0,0,0-.71-2.67c-.53-1.61-1.35-3.82-2.34-6.22s-1.94-4.54-2.67-6.08A11.73,11.73,0,0,0,430,416Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M454.58,308.5s13.78-7.2,14.05-19.23a.52.52,0,0,0-.81-.44C465.77,290.25,460.1,295.12,454.58,308.5Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.77,293.41a12.43,12.43,0,0,0-1.72,2.15l-3.89,5.37c-1.45,2-2.77,3.82-3.9,5.36a17,17,0,0,0-1.57,2.26,11.41,11.41,0,0,0,1.9-2c1.09-1.31,2.53-3.17,4-5.28s2.84-4,3.76-5.48A13.23,13.23,0,0,0,465.77,293.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.78,340.37S454,334,455,322a.51.51,0,0,0-.78-.49C452.06,322.83,446.1,327.35,439.78,340.37Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.86,326a13.38,13.38,0,0,0-1.84,2l-4.21,5.12-4.21,5.12a15.17,15.17,0,0,0-1.71,2.16,11.7,11.7,0,0,0,2-1.89c1.17-1.24,2.72-3,4.36-5s3.08-3.87,4.08-5.24A11.56,11.56,0,0,0,451.86,326Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.94,375.91s9.75-12.11,5.18-23.24a.52.52,0,0,0-.92-.09C450.89,354.7,447.65,361.45,447.94,375.91Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.15,357.6a13.55,13.55,0,0,0-.71,2.66c-.41,1.87-.88,4.06-1.41,6.48l-1.42,6.47a15.38,15.38,0,0,0-.54,2.7,10.81,10.81,0,0,0,.93-2.59c.48-1.64,1.06-3.92,1.6-6.45s1-4.85,1.24-6.53A12.45,12.45,0,0,0,452.15,357.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.29,417.74s14.08-6.58,14.88-18.59a.51.51,0,0,0-.78-.47C450.28,400,444.4,404.62,438.29,417.74Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.13,403.16a14,14,0,0,0-1.81,2.07l-4.11,5.2c-1.55,1.94-2.94,3.69-4.14,5.18a15.16,15.16,0,0,0-1.66,2.19,11.46,11.46,0,0,0,2-1.92c1.15-1.26,2.67-3.05,4.27-5.09s3-3.92,4-5.31A12.49,12.49,0,0,0,450.13,403.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.24,356.62s0,.12,0,.34,0,.6,0,1c.05.94.1,2.2.17,3.77.18,3.32.44,7.94.74,13.47h0v0c1,5.62,3.87,11.86,7.72,17.91,2.82,4.46,5.78,8.52,8.34,12.29a86.24,86.24,0,0,1,6.24,10.33,43.39,43.39,0,0,1,2.93,7.58c.25.93.43,1.65.54,2.15a3.45,3.45,0,0,0,.21.75,6.15,6.15,0,0,0-.1-.78c-.07-.5-.22-1.24-.43-2.18a40.35,40.35,0,0,0-2.78-7.7,80.93,80.93,0,0,0-6.17-10.45c-2.53-3.8-5.48-7.86-8.29-12.3-3.82-6-6.67-12.16-7.72-17.7v0c-.39-5.53-.72-10.14-.95-13.45-.13-1.57-.23-2.83-.3-3.77,0-.39-.08-.72-.1-1A1.48,1.48,0,0,0,410.24,356.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.62,392s-6-14.36,1.54-23.77a.51.51,0,0,1,.9.18C421.73,370.79,423,378.17,418.62,392Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.71,373.22a12.44,12.44,0,0,0-.47,2.72c-.21,1.68-.45,4-.64,6.61s-.27,4.93-.27,6.64a10.85,10.85,0,0,0,.17,2.75,15.63,15.63,0,0,0,.24-2.74c.13-1.91.28-4.14.44-6.61s.33-4.71.47-6.62A13.93,13.93,0,0,0,419.71,373.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M418.62,392s-6-14.36,1.54-23.77a.51.51,0,0,1,.9.18C421.73,370.79,423,378.17,418.62,392Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M437.1,426.58s-4.78-14.8,3.46-23.57a.52.52,0,0,1,.88.25C441.91,405.71,442.54,413.17,437.1,426.58Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.7,408a12.38,12.38,0,0,0-.69,2.67c-.35,1.66-.77,4-1.17,6.53s-.67,4.9-.81,6.6a11.22,11.22,0,0,0,0,2.76,16.14,16.14,0,0,0,.46-2.71c.28-1.89.61-4.11,1-6.56s.71-4.66,1-6.55A13.44,13.44,0,0,0,439.7,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M437.1,426.58s-4.78-14.8,3.46-23.57a.52.52,0,0,1,.88.25C441.91,405.71,442.54,413.17,437.1,426.58Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M411,374.43s-12.74-8.92-11.45-20.88a.51.51,0,0,1,.85-.34C402.28,354.88,407.28,360.45,411,374.43Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M411,374.43s-12.74-8.92-11.45-20.88a.51.51,0,0,1,.85-.34C402.28,354.88,407.28,360.45,411,374.43Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M401.88,358a12.43,12.43,0,0,0,1.06,2.54c.72,1.54,1.78,3.64,3,5.92s2.42,4.32,3.33,5.75a11.8,11.8,0,0,0,1.62,2.24,14.6,14.6,0,0,0-1.26-2.45c-.92-1.67-2-3.64-3.18-5.81l-3.16-5.83A13.64,13.64,0,0,0,401.88,358Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432,411.91s-15.36-2.4-19.47-13.7a.51.51,0,0,1,.61-.68C415.5,398.21,422.44,401,432,411.91Z",
    style: {
      fill: "#7AC08E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M432,411.91s-15.36-2.4-19.47-13.7a.51.51,0,0,1,.61-.68C415.5,398.21,422.44,401,432,411.91Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M416.52,401.2a12,12,0,0,0,2.07,1.82c1.33,1.06,3.2,2.48,5.31,4s4.08,2.81,5.53,3.69a11.52,11.52,0,0,0,2.44,1.3,14.39,14.39,0,0,0-2.22-1.64l-5.41-3.82-5.4-3.85A14.09,14.09,0,0,0,416.52,401.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "450.14 440.18 445.73 469.08 428.14 469.05 422.21 440.18 450.14 440.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.08,449.46a4.91,4.91,0,0,0,.81-2.42,2.61,2.61,0,0,0-1.19-2.48,2.84,2.84,0,0,0-2.95.24,4.3,4.3,0,0,0-1.68,2.65,11.16,11.16,0,0,0-.22,3.27,10.57,10.57,0,0,0,.71,3.33,7.35,7.35,0,0,0,2,2.91,5.69,5.69,0,0,0,3.39,1.42,6.23,6.23,0,0,0,3.52-1,10.71,10.71,0,0,0,2.63-2.38,5.79,5.79,0,0,0,1.33-3.17,3.71,3.71,0,0,0-1.25-3.07,2.88,2.88,0,0,0-3.12-.19,3.38,3.38,0,0,0-1.8,2.36,4.51,4.51,0,0,0,2.23,4.57,6.19,6.19,0,0,0,4.25.62,9.6,9.6,0,0,0,3-1.19,16.71,16.71,0,0,0,1.7-1.14,2.86,2.86,0,0,0,.54-.47,6.75,6.75,0,0,0-.6.39c-.39.25-1,.64-1.73,1.06a9.81,9.81,0,0,1-3,1.08,6,6,0,0,1-4-.64,4.18,4.18,0,0,1-2-4.2,3,3,0,0,1,1.6-2.06,2.45,2.45,0,0,1,2.65.16,3.26,3.26,0,0,1,1.07,2.69,5.34,5.34,0,0,1-1.25,2.91,10.4,10.4,0,0,1-2.5,2.26,5.79,5.79,0,0,1-3.25.95,5.3,5.3,0,0,1-3.1-1.3,7,7,0,0,1-1.91-2.72,10.19,10.19,0,0,1-.69-3.19,10.78,10.78,0,0,1,.19-3.13,3.87,3.87,0,0,1,1.49-2.41,2.45,2.45,0,0,1,2.51-.25,2.26,2.26,0,0,1,1,2.13,4.51,4.51,0,0,1-.73,2.24,6.49,6.49,0,0,1-3.28,2.46,7.19,7.19,0,0,1-3.12.37,8.06,8.06,0,0,1-2.6-.77s0,0,.14.11a5.14,5.14,0,0,0,.47.26,6.19,6.19,0,0,0,2,.59,7.16,7.16,0,0,0,3.24-.31,6.77,6.77,0,0,0,3.48-2.52",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPassword);
export default __webpack_public_path__ + "static/media/forgot-password.db67cea2ce4d7cf6abb013c3e093ae64.svg";
export { ForwardRef as ReactComponent };